import React from "react";
import styled from "styled-components";
import { primaryGradient, secondaryGradient } from "../GradientBox";
import { mobileQuery } from "../MediaQuery";

export const SlantedSection: React.FC<{
  offset: number;
  height?: number;
  width: number;
  justifyContent: string;
  alignItems?: string;
  gradient?: boolean;
  secondaryGradient?: boolean;
  color?: string;
  skewLeft?: boolean;
  children?: React.ReactNode;
}> = (props) => (
  <Wrapper>
    <SlantedRectangle
      offset={props.offset}
      height={props.height}
      width={props.width}
    >
      <Background
        gradient={props.gradient ?? false}
        secondaryGradient={props.secondaryGradient ?? false}
        skewLeft={props.skewLeft ?? true}
        color={props.color}
      />
      <Content
        justifyContent={props.justifyContent}
        alignItems={props.alignItems}
      >
        {props.children}
      </Content>
    </SlantedRectangle>
  </Wrapper>
);

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
  width: 120%;
  margin: auto;
  overflow: visible;

  ${mobileQuery`
      width: 100%;
    `}
`;

const SlantedRectangle = styled.div<{
  offset: number;
  height?: number;
  width: number;
}>`
  margin-left: ${(props) => (props.offset < 0 ? props.offset * 2 : 0)}px;
  margin-right: ${(props) => (props.offset > 0 ? -props.offset * 2 : 0)}px;
  ${(props) =>
    props.height !== undefined &&
    `height: ${props.height}px;
  `}
  width: ${(props) => props.width}px;

  padding: 0;

  position: relative;

  ${mobileQuery`
    padding: 34px 0;
    margin-left: 0;
    margin-right: 0;
    width: 436px;
  `}
`;

const Background = styled.div<{
  gradient: boolean;
  secondaryGradient: boolean;
  color?: string;
  skewLeft: boolean;
}>`
  transform: skew(${(props) => (props.skewLeft ? 30 : -30)}deg);
  ${(props) =>
    props.gradient &&
    `
    background: ${primaryGradient};
  `}
  ${(props) =>
    props.secondaryGradient &&
    `
    background: ${secondaryGradient};
  `}
  ${(props) =>
    props.color !== undefined &&
    `
    background: ${props.color};
  `}
  width: 100%;
  height: 100%;
`;

const Content = styled.div<{
  justifyContent: string;
  alignItems?: string;
}>`
  position: absolute;
  top: 0;
  display: flex;
  justify-content: ${(props) => props.justifyContent};
  ${(props) =>
    props.alignItems !== undefined &&
    `
    align-items: ${props.alignItems};
  `}
  width: 100%;
  height: 100%;

  ${mobileQuery`
    justify-content: center;
  `}
`;
